// import React from "react";
// import ReadOnlyRow from "./ReadOnlyRow";
// import EditableRow from "./EditableRow";

// const RecordsFilteredView = ({
//     records,
//     editContactId,
//     editFormData,
//     handleEditClick,
//     handleDeleteClick,
//     handleDownloadRow,
//     handleEditFormChange,
//     handleEditFormSubmit,
//     handleCancelClick,
//     isLoadingSave
// }) => {
//     return (
//         <div className="overflow-auto w-100 mt3">
//             <table className="collapse ba br2 b--black-10 pv2 ph3 w-100 bg-white shadow-2">
// <thead>
//   <tr className="bg-gold white">

//     <th className="pa3 tc">
//       Select
//     </th>

//     <th className="pa3 tl">ID</th>

//     <th className="pa3 tl">
//       Farmer ID
//     </th>

//     <th className="pa3 tl">
//       Product Type
//     </th>

//     <th className="pa3 tr">
//       Weight
//     </th>

//     <th className="pa3 tl">
//       Company
//     </th>

//     <th className="pa3 tl">
//       Full Name
//     </th>

//     <th className="pa3 tc">
//       Approval
//     </th>

//     <th className="pa3 tc">
//       Date Approved
//     </th>

//     <th className="pa3 tc">
//       Date Recorded
//     </th>

//     <th className="pa3 tc">
//       Actions
//     </th>

//   </tr>
// </thead>
//             <tbody>
//                 {records.map((contact) => (
//                     <React.Fragment key={contact.id}>
//                         {editContactId === contact.id ? (
//                             <EditableRow
//                                 handleEditFormSubmit={handleEditFormSubmit}
//                                 isLoadingSave={isLoadingSave}
//                                 handleEditFormChange={handleEditFormChange}
//                                 handleCancelClick={handleCancelClick}
//                             />
//                         ) : (
//                             <ReadOnlyRow
//                                 contact={contact}
//                                 handleEditClick={handleEditClick}
//                                 handleDeleteClick={handleDeleteClick}
//                                 handleDownloadRow={handleDownloadRow}
//                             />
//                         )}
//                     </React.Fragment>
//                 ))}
//             </tbody>
      
//         </table>
//          </div> 
//   );
// };

// export default RecordsFilteredView;


import React from "react";
import ReadOnlyRow from "./ReadOnlyRow";
import EditableRow from "./EditableRow";
import "./style.css"

const RecordsFilteredView = ({
  records,
  editContactId,
  editFormData,

  handleEditClick,
  handleDeleteClick,
  handleDownloadRow,

  handleEditFormChange,
  handleEditFormSubmit,
  handleCancelClick,

  isLoadingSave,

  selectedRecords = [],
  handleSelectRecord,

  selectAll,
  handleSelectAll,

  sortColumn,
  sortDirection,
  handleSort,
}) => {
  const renderSortIcon = (column) => {
    if (sortColumn !== column) return " ↕";
    return sortDirection === "asc" ? " ▲" : " ▼";
  };

  return (
    <div className="overflow-auto w-100 mt3 bg-white br3 shadow-2">

      <table
        className="records-table collapse bg-white"
        style={{
          minWidth: "1700px",
        }}
      >

<thead className="sticky-header">

          <tr
            className="bg-gold black"
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
            }}
          >
            {/* Select */}

            <th className="pa3 tc nowrap bb b--black-10">

              <input
                type="checkbox"
                checked={selectAll}
                onChange={(e) =>
                  handleSelectAll &&
                  handleSelectAll(e.target.checked)
                }
              />

            </th>

            {/* ID */}

            <th
              className="pa3 tl nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("id")}
            >
              ID
              {renderSortIcon("id")}
            </th>

            {/* Farmer ID */}

            <th
              className="pa3 tl nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("farmerid")}
            >
              Farmer ID
              {renderSortIcon("farmerid")}
            </th>

            {/* Product */}

            <th
              className="pa3 tl nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("producttype")}
            >
              Product Type
              {renderSortIcon("producttype")}
            </th>

            {/* Weight */}

            <th
              className="pa3 tr nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("weight")}
            >
              Weight
              {renderSortIcon("weight")}
            </th>

            {/* Company */}

            <th
              className="pa3 tl nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("companyname")}
            >
              Company
              {renderSortIcon("companyname")}
            </th>

            {/* Full Name */}

            <th
              className="pa3 tl nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("fullname")}
            >
              Full Name
              {renderSortIcon("fullname")}
            </th>

            {/* Approval */}

            <th
              className="pa3 tc nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("approved_status")}
            >
              Approval
              {renderSortIcon("approved_status")}
            </th>

            {/* Date Approved */}

            <th
              className="pa3 tc nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("date_approved")}
            >
              Date Approved
              {renderSortIcon("date_approved")}
            </th>

            {/* Recorded */}

            <th
              className="pa3 tc nowrap pointer bb b--black-10 f2 fw5"
              onClick={() => handleSort?.("daterecorded")}
            >
              Date Recorded
              {renderSortIcon("daterecorded")}
            </th>

            {/* Actions */}

            <th className="pa3 tc nowrap bb b--black-10 f2 fw5">
              Actions
            </th>

          </tr>

        </thead>

        <tbody>

          {records?.length > 0 ? (
            records.map((contact) => (
              <React.Fragment key={contact.id}>

                {editContactId === contact.id ? (

                  <EditableRow
                    editFormData={editFormData}
                    handleEditFormSubmit={handleEditFormSubmit}
                    isLoadingSave={isLoadingSave}
                    handleEditFormChange={handleEditFormChange}
                    handleCancelClick={handleCancelClick}
                  />

                ) : (

                  <ReadOnlyRow
                    contact={contact}
                    handleEditClick={handleEditClick}
                    handleDeleteClick={handleDeleteClick}
                    handleDownloadRow={handleDownloadRow}
                    selectedRecords={selectedRecords}
                    handleSelectRecord={handleSelectRecord}
                  />

                )}

              </React.Fragment>
            ))
          ) : (
            <tr>
              <td
                colSpan="11"
                className="tc pa5 silver f4"
              >
                No records found
              </td>
            </tr>
          )}

        </tbody>

      </table>

    </div>
  );
};

export default RecordsFilteredView;